import fetcher from './authorFetchers'

// 作者基本信息
export const fetchInfo = (params) => {
  return fetcher.post('/v1/ugc/author/detail', params)
}

// 作者上传的壁纸
export const fetchWorks = (params) => {
  return fetcher.post('/v1/ugc/author/works', params)
}
